import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


export interface Transaction {
  orderid: string;
  date: string;
  billingname: string;
  total: string;
  paymentstatus: string;
}

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss'
})
export class AnalyticsComponent {

  transactions: Transaction[] = [
    {
      orderid: '#NZ1563',
      date: '28 Mar, 2020',
      billingname: 'Frank Dean',
      total: '$164',
      paymentstatus: 'Unpaid'
    },
    {
      orderid: '#NZ1564',
      date: '28 Mar, 2020',
      billingname: 'Eddy Torres',
      total: '$141',
      paymentstatus: 'Paid'
    }
  ];

  statData: any = [
    {
      icon: 'ri-stack-line',
      title: 'Total Revenue (YTD)',
      value: '0'
    }, {
      icon: 'ri-folder-user-line',
      title: 'Customer Acquisition',
      value: '0'
    }, {
      icon: 'ri-wallet-2-line',
      title: 'Document Volume',
      value: '0'
    }, {
      icon: 'ri-code-s-slash-line',
      title: 'Avg Documents/Customer',
      value: '0'
    }
  ];

  customerStats: any = [
    {
      rank: 1,
      customerName: 'Acme Corp',
      plan: 'Enterprise',
      documents: 12,
      mrr: 5000,
      apiCalls: 1200
    },
    {
      rank: 2,
      customerName: 'TechNova Solutions',
      plan: 'Growth',
      documents: 12,
      mrr: 5000,
      apiCalls: 980
    },
    {
      rank: 3,
      customerName: 'BlueWave Systems',
      plan: 'Enterprise',
      documents: 12,
      mrr: 5000,
      apiCalls: 1500
    },
    {
      rank: 4,
      customerName: 'Startify Labs',
      plan: 'Starter',
      documents: 12,
      mrr: 5000,
      apiCalls: 320
    },
    {
      rank: 5,
      customerName: 'NextGen Soft',
      plan: 'Growth',
      documents: 12,
      mrr: 5000,
      apiCalls: 760
    }
  ];

  planUsage = [
    {
      name: 'Enterprise',
      count: 25,
      percentage: 59.5,
      color: 'bg-primary'
    },
    {
      name: 'Growth',
      count: 18,
      percentage: 42.3,
      color: 'bg-success'
    },
    {
      name: 'Starter',
      count: 10,
      percentage: 23.8,
      color: 'bg-secondary'
    }
  ];

  documentStatusStats = [
    {
      label: 'Signed',
      count: 25,
      percentage: 59.5,
      color: 'bg-success'
    },
    {
      label: 'Pending',
      count: 18,
      percentage: 42.3,
      color: 'bg-warning'
    },
    {
      label: 'Expired',
      count: 10,
      percentage: 23.8,
      color: 'bg-secondary'
    },
    {
      label: 'Rejected',
      count: 5,
      percentage: 12.5,
      color: 'bg-danger'
    }
  ];

  term: any;
  loading: boolean = false;
  breadCrumbItems: Array<{}>;

  constructor(private sanitizer: DomSanitizer) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Analytics', active: true }];
  }

  errorUrl: SafeResourceUrl;
  projectHealthUrl: SafeResourceUrl;
  apiPerformanceUrl: SafeResourceUrl;
  securityAccessUrl: SafeResourceUrl;
  selectedTab = 'api';



  ngOnInit(): void {
    const errorUrl: string = "https://metabase.avsstech.in/public/dashboard/e5e0afcf-bdf4-4c31-9d2f-9a7a6557b232" // Error Monitoring Dashboard
    const projectHealthUrl: string = "https://metabase.avsstech.in/public/dashboard/d3dc1907-3a73-4c3b-807e-2a66e7efd671" //  Project Health Dashboard
    const apiPerformanceUrl: string = "https://metabase.avsstech.in/public/dashboard/a4b59d1f-3fd9-4952-acd0-cc6a98b28c1b"; // API Performance Dashboard
    const securityAccessUrl: string = "https://metabase.avsstech.in/public/dashboard/54e09d6a-1300-48b5-952c-79eb7dbed43d"; // API Performance Dashboard

    this.apiPerformanceUrl = this.sanitizeUrl(apiPerformanceUrl);
    this.errorUrl = this.sanitizeUrl(errorUrl);
    this.projectHealthUrl = this.sanitizeUrl(projectHealthUrl);
    this.securityAccessUrl = this.sanitizeUrl(securityAccessUrl);
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  selectTab(tab: string) {
    this.selectedTab = tab;
  }

}
